import React, { useState, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);

function TreeMap({ categories, data, series, title = "", height}) {
	const { theme, isTabletScreen } = useVsiAppContext();
	const basicTextStyle = {
		color: styles[theme].textColor,
		fontFamily: styles[theme].fontFamily,
	};

	const updateSeries = (series, data) => {
		if (series) return series;
		else if (data)
			return [
				{
					type: 'treemap',
					layoutAlgorithm: 'squarified',
					data,
				},
			];
		return [];
	};

	const [chartOptions, setChartOptions] = useState(() => {
		return {
			mapNavigation: {
				enabled: false
			},
			credits: {
				enabled: false,
			},
			title: {
				text: title || '',
			},
			chart: {
				type: "treemap",
				backgroundColor: styles[theme].cardBgColor,
				color: styles[theme].textColor,
				height: height || 500
			},
			legend: {
				itemStyle: basicTextStyle,
				align: "center",
			},
			series: updateSeries(series, data),
		};
	});

	useEffect(() => {
		setChartOptions(() => {
			return {
				...chartOptions,
				chart: {
					...chartOptions.chart,
					color: styles[theme].textColor,
					backgroundColor: styles[theme].cardBgColor,
					height: height || 500
				},
				title: {
					...chartOptions.title,
					text: title || '',
					style: basicTextStyle,
				},
				tooltip: {
					backgroundColor: styles[theme].altBgColor,
					style: basicTextStyle,
				},
				labels: {
					...chartOptions.labels,
					style: basicTextStyle,
				},
				legend: {
					...chartOptions.legend,
					itemStyle: basicTextStyle,
					align: "center",
				},
				series: updateSeries(series, data),
			};
		});
		// eslint-disable-next-line
	}, [categories, series, data, theme, isTabletScreen]);

	return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
}

TreeMap.displayName = "TreeMap"

export default withErrorBoundary(TreeMap, GeneralErrorBoundary);
